var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Responsive drawer component for the menu.
 *
 * @component
 * @param {Props} props - The component props.
 * @param {React.ReactNode} props.children - The children components.
 * @returns {JSX.Element} The rendered menu component.
 */
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Link, } from "@mui/material";
import SportsBar from "@mui/icons-material/SportsBar";
import HomeIcon from "@mui/icons-material/Home";
import TopBar from "../TopBar";
import styles from "./Menu.module.css";
var drawerWidth = 240;
export default function ResponsiveDrawer(props) {
    var _a = React.useState(false), mobileOpen = _a[0], setMobileOpen = _a[1];
    var handleDrawerToggle = function () {
        setMobileOpen(!mobileOpen);
    };
    var drawer = (_jsx(_Fragment, { children: _jsxs(List, __assign({ className: styles.menuList, component: "nav", "aria-label": "Main navigation", role: "navigation" }, { children: [_jsx(Link, __assign({ component: RouterLink, to: "/", underline: "none", "aria-label": "Navigate to home page" }, { children: _jsx(ListItem, __assign({ disablePadding: true, className: styles.menuListItem }, { children: _jsxs(ListItemButton, __assign({ role: "menuitem", "aria-label": "Home page" }, { children: [_jsx(ListItemIcon, __assign({ "aria-hidden": "true" }, { children: _jsx(HomeIcon, { color: "secondary" }) })), _jsx(ListItemText, { primary: "Home", color: "secondary" })] })) })) })), _jsx(Link, __assign({ component: RouterLink, to: "/beer", underline: "none", "aria-label": "Navigate to breweries list" }, { children: _jsx(ListItem, __assign({ disablePadding: true, className: styles.menuListItem }, { children: _jsxs(ListItemButton, __assign({ role: "menuitem", "aria-label": "Breweries list page" }, { children: [_jsx(ListItemIcon, __assign({ "aria-hidden": "true" }, { children: _jsx(SportsBar, { color: "secondary" }) })), _jsx(ListItemText, { primary: "Breweries List", color: "secondary" })] })) })) }))] })) }));
    return (_jsxs(Box, __assign({ sx: { display: "flex" } }, { children: [_jsx("a", __assign({ href: "#main-content", className: "skip-link" }, { children: "Skip to main content" })), _jsx(TopBar, { drawerWidth: drawerWidth, handleDrawerToggle: handleDrawerToggle }), _jsxs(Box, __assign({ component: "nav", sx: { width: { sm: drawerWidth }, flexShrink: { sm: 0 } }, "aria-label": "Main navigation drawer" }, { children: [_jsx(Drawer, __assign({ variant: "temporary", open: mobileOpen, onClose: handleDrawerToggle, ModalProps: {
                            keepMounted: true,
                        }, sx: {
                            display: { xs: "block", sm: "none" },
                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: drawerWidth,
                            },
                        }, "aria-label": "Mobile navigation menu" }, { children: drawer })), _jsx(Drawer, __assign({ variant: "permanent", sx: {
                            display: { xs: "none", sm: "block" },
                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: drawerWidth,
                            },
                        }, open: true, "aria-label": "Desktop navigation menu" }, { children: drawer }))] })), _jsxs(Box, __assign({ component: "main", sx: {
                    flexGrow: 1,
                    p: 3,
                    width: { sm: "calc(100% - ".concat(drawerWidth, "px)"), background: "#f7f7f7" },
                }, role: "main", "aria-label": "Main content area", id: "main-content", tabIndex: -1 }, { children: [_jsx(Toolbar, {}), props.children] }))] })));
}
